import React from 'react';
import {useTranslation} from 'react-i18next';

import './ProductDocumentLinks.scss';

const ProductDocumentLinks = ({product}) => {
    const {t} = useTranslation();
    const attachments = product?.attachments || [];
    const attachment = attachments.find(item => item.label === 'product_card');
    const href = attachment?.link || attachment?.frontend_url;

    if (!href) {
        return null;
    }

    return (
        <div className="product-document-links">
            <a
                className="product-document-links__link"
                href={href}
                target="_blank"
                rel="noopener noreferrer"
            >
                {t('product_card')}
            </a>
        </div>
    );
};

export default ProductDocumentLinks;
